import { render, staticRenderFns } from "./BasketItemList.vue?vue&type=template&id=c39a15aa&"
import script from "./BasketItemList.vue?vue&type=script&lang=js&"
export * from "./BasketItemList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports